export enum UserPaymentType {
    MONTHLY_RATE,
    HOURLY_RATE,
}
